import {
  getDatadogLogger,
  logError as logErr
} from '@storebrand-digital/common-datadog';

const logger = getDatadogLogger();

export const logError = (
  message: string,
  messageContext?: object,
  error?: Error
) => {
  logger.error(message, messageContext, error);
};

// Use this for cases where we do not know what type of error will be caught
export const logUnknownError = (error: unknown, context?: object) => {
  logErr(error, context);
};

export const logInfo = (
  message: string,
  messageContext?: object,
  error?: Error
) => {
  logger.info(message, messageContext, error);
};

export const setLogContext = (context: object) => {
  logger.setContext(context);
};

export const setLogContextProperty = (key: string, value: any) => {
  logger.setContextProperty(key, value);
};
